@use '@fpsm/cxy-scss' as cxy;

.distanceRefinementContainer {
  @include cxy.stack(var(--cxy-spacing-4));
  margin-top: var(--distance-refinement-margin-top, var(--cxy-spacing-2));
}

.distanceRefinementItems {
  @include cxy.stack(var(--cxy-spacing-4));
}

.resetButton {
  align-self: center;
}
